<template>
  <div>
    <c-tab
      type="horizon"
      :tabItems.sync="tabItems"
      :inlineLabel="true"
      :dense="true"
      :height="tabHeight"
      v-model="tab"
    >
      <template v-slot:default="tab">
        <component
          :is="tab.component"
          :popupParam.sync="popupParam"
          :traning.sync="traning"
          :disabled="disabled"
          :isOld="isOld"
          :attachInfo.sync="attachInfo"
          :updateBtnProps.sync="updateBtnProps"
          @getDetail="getDetail"
          @closePopup="closePopup"
        />
      </template>
    </c-tab>
  </div>
</template>
<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'traningDetail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        sopEmergencyTrainingId: '',
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      tab: 'scenario',
      authUpdateData: {
        title: '훈련',
        flag: false,
      },
      traning: {
        sopEmergencyTrainingId: '',
        plantCd: '',
        trainingName: '',
        eapTrainingTypeCd: null,
        checkPurpose: '',
        trainingStartDate: '',
        trainingStartTime: '',
        trainingEndDate: '',
        trainingEndTime: '',
        emergencyPlanName: '',
        summary: '',
        trainingWay: '',
        trainingArea: '',
        trainingInstructUserIds: [],
        sopEmergencyPlanId: '',
        trainingScenarioNo: '',
        evaluationUserId: '',
        evaluationOpinon: '',
        trainingCompleteFlag: 'N',
        regUserId: '',
        chgUserId: '',  

        emergencyTrainingUsersModels: [],
        emergencyTrainingEvaluationModels: [],

        // 훈련시나리오 
        trainingScenarioName: '',
        preRequisites: '',
        materials: '',
        indirectNotice: '',
        directlyNotice: '',
        trainingContentsOutline: '',
        trainingContentsSummary: '',
        revisionNum: '',
      },
      attachInfo: {
        isSubmit: '',
        taskClassCd: 'TRAINING_PICTURE',
        taskKey: '',
      },
      getUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    tabHeight() {
      return String(this.contentHeight - 36);
    },
    disabled() {
      return this.traning.trainingCompleteFlag === 'Y'
        && !this.authUpdateData.flag
    },
    isOld() {
      return Boolean(this.popupParam.sopEmergencyTrainingId)
    },
    updateBtnProps() {
      return {
        data: this.authUpdateData,
        flagCondition: this.traning.trainingCompleteFlag !== 'Y',
        btnEditable: this.editable 
          && this.traning.trainingCompleteFlag === 'Y'
          && Boolean(this.popupParam.sopEmergencyTrainingId)
      }
    },
    tabItems() {
      let items = [
        { name: 'scenario', icon: 'info', label: '비상대응훈련 상세', component: () => import(`${'./traningInfo.vue'}`) },
      ];
      if (this.popupParam.sopEmergencyTrainingId) {
        items.push(
          { name: 'assess', icon: 'assessment', label: '훈련 평가', component: () => import(`${'./traningAssess.vue'}`) },
        )
      }
      return items;
    },
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.getUrl = selectConfig.sop.eap.training.plan.get.url;
      // code setting
      // list setting
      this.getDetail();
    },
    getDetail() {
      if (this.popupParam.sopEmergencyTrainingId) {
        this.$http.url = this.$format(this.getUrl, this.popupParam.sopEmergencyTrainingId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.$_.extend(this.traning, _result.data)
          this.$set(this.attachInfo, 'taskKey', this.popupParam.sopEmergencyTrainingId)
        },);
      }
    },
    closePopup() {
      this.$emit('closePopup');  
    }
  }
};
</script>